import { FC } from "react";
import { Path, Svg } from "react-native-svg";
import { tSvgProps } from "../types";

const PdChevronDown: FC<tSvgProps> = (props) => (
  <Svg viewBox="0 0 7 4" fill="none" {...props}>
    <Path
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      focusable={false}
      d="M3.5 4 0 .5V0h.5l3 3 3-3H7v.5L3.5 4Z"
      fill="currentColor"
    />
  </Svg>
);

export default PdChevronDown;
